import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { Badge } from "./ui/badge";
import { MapPin, Package, BadgeCheck } from "lucide-react";

const PLACEHOLDER = "https://images.pexels.com/photos/3806252/pexels-photo-3806252.jpeg";

export const ProductCard = ({ product }) => {
  const img = product.images && product.images.length > 0 ? fileUrl(product.images[0]) : PLACEHOLDER;
  return (
    <Link
      to={`/product/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className="group block border border-border bg-white transition-transform duration-150 hover:-translate-y-1 hover:border-foreground"
    >
      <div className="aspect-[4/3] overflow-hidden bg-muted border-b border-border relative">
        <img src={img} alt={product.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
             onError={(e) => { e.currentTarget.src = PLACEHOLDER; }} />
        {product.wiltom_verified && (
          <Badge className="absolute top-2 left-2 rounded-none bg-primary text-white text-[10px] uppercase tracking-wider" data-testid={`wiltom-verified-${product.product_id}`}>
            <BadgeCheck className="h-3.5 w-3.5 mr-1" /> WILTOM Verified
          </Badge>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="label-caps text-primary">{product.category}</span>
          <Badge variant="outline" className="rounded-none text-[10px] uppercase tracking-wider">
            {product.condition}
          </Badge>
        </div>
        <h3 className="font-display font-bold text-lg tracking-tight leading-tight line-clamp-1">{product.title}</h3>
        <p className="text-sm text-muted-foreground line-clamp-1 mt-1">
          {product.brand ? `${product.brand} · ` : ""}{product.size || "—"}
        </p>
        <div className="flex items-end justify-between mt-4">
          <div>
            <div className="font-display font-black text-xl">£{Number(product.price).toLocaleString()}</div>
            <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1">
              <MapPin className="h-3 w-3" /> {product.location || "—"}
            </div>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Package className="h-3 w-3" /> {product.quantity} in stock
          </div>
        </div>
      </div>
    </Link>
  );
};
